export enum GTMOrderType {
    Equipment = 'Equipment',
    Services = 'Services',
}

export enum GTMItemType {
    Product = 'product',
    Gift = 'gift',
}

export type GTMItemTypeValue = `${GTMItemType}`;

export enum GTMItemServiceType {
    Modification = 'modification',
    NewSale = 'new sale',
}

export type GTMItemServiceTypeValue = GTMItemServiceType | string;

export type GTMEcommerceItem = {
    item_type?: GTMItemTypeValue;
    item_id?: string;
    item_name?: string;
    item_brand?: string;
    item_variant?: string;
    item_category?: string;
    item_list_id?: string;
    item_list_name?: string;
    index?: number;
    original_price?: number;
    price?: number;
    discount?: number | string;
    quantity?: number;
    commitment_type?: string;
    service_type?: GTMItemServiceTypeValue;
    currency?: string;
    funnel_category?: string;
    funnel_variant?: string;
    previous_plan?: string;
    previous_operator?: string;
};

export type GTMEcommerce = {
    order_type?: GTMOrderType | string;
    segment?: string;
    currency?: string;
    value?: number;
    item_list_name?: string;
    item_category?: string;
    gift_included?: boolean;
    coupon?: string;
    payment_type?: string;
    payment_method?: string;
    sign_method?: string;
    bank?: string;
    transaction_id?: string;
    subscriber_id?: string;
    shipping_tier?: string;
    leasing_monthly_value?: number;
    instant_value?: number;
    leasing_period?: number;
    search_text?: string;
    suggestion_text?: string;
    click_name?: string;
    items?: GTMEcommerceItem[];
};

export type GTMEcommerceEvent = {
    event: string;
    ecommerce: GTMEcommerce;
    [key: string]: unknown;
};

export type GTMEventName =
    | 'accept_terms_and_conditions'
    | 'add_client_info'
    | 'add_payment_info'
    | 'add_shipping_info'
    | 'add_to_cart'
    | 'begin_checkout'
    | 'cancel_payment'
    | 'cancel_sign_document'
    | 'confirm_payment'
    | 'document_sign'
    | 'formOpen'
    | 'formStart'
    | 'formSubmissionSuccess'
    | 'remove_from_cart'
    | 'purchase'
    | 'purchase_event'
    | 'autocomplete_product_click'
    | 'autocomplete_suggestion_click'
    | 'product_recommendation_click'
    | 'search_form_submit'
    | 'search_product_click'
    | 'search_query'
    | 'search_result_click'
    | 'search_zero_results'
    | 'successful_credit_check'
    | 'select_item'
    | 'select_modify_service'
    | 'sign_document'
    | 'unsuccessful_credit_check'
    | 'view_item'
    | 'view_item_list'
    | 'OneTrustLoaded'
    | 'OptanonLoaded'
    | 'OneTrustGroupsUpdated'
    | 'native_survey';

export type TrackingItem = {
    type?: GTMItemTypeValue;
    id?: string;
    name?: string;
    brand?: string;
    variant?: string;
    category?: string;
    listId?: string;
    listName?: string;
    index?: number;
    originalPrice?: number;
    price?: number;
    discount?: number | string;
    quantity?: number;
    commitmentType?: string;
    serviceType?: GTMItemServiceTypeValue;
    currency?: string;
    funnelCategory?: string;
    funnelVariant?: string;
    previousPlan?: string;
    previousOperator?: string;
};

export type TrackingCommerce = {
    orderType?: GTMOrderType | string;
    segment?: string;
    currency?: string;
    value?: number;
    itemListName?: string;
    itemCategory?: string;
    giftIncluded?: boolean;
    coupon?: string;
    paymentType?: string;
    paymentMethod?: string;
    signMethod?: string;
    bank?: string;
    transactionId?: string;
    subscriberId?: string;
    shippingTier?: string;
    leasingMonthlyValue?: number;
    instantValue?: number;
    leasingPeriod?: number;
    searchText?: string;
    suggestionText?: string;
    clickName?: string;
    items?: TrackingItem[];
    additionalProperties?: Record<string, unknown>;
};
